import { render } from "./courses.vue?vue&type=template&id=5dd55c17&scoped=true"
import script from "./courses.vue?vue&type=script&lang=js"
export * from "./courses.vue?vue&type=script&lang=js"

import "./courses.vue?vue&type=style&index=0&id=5dd55c17&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5dd55c17"

export default script